import React from 'react';
import {Menu, Layout, Icon} from 'antd';
import {Link} from 'react-router-dom';
const {Sider} = Layout;

class Sidebar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: false
        }
    }

    render() {
        const {auth: {isAuthenticated}, selectedMenu} = this.props;

        if (!isAuthenticated) {
            return <div />;
        }
        const menuItems = [
            {key: '/contractor/profile', label: 'My Details', icon: 'user'},
            {key: '/contractor/admins', label: 'Admin Users', icon: 'team'},
            {key: '/contractor/insurances', label: 'Insurances', icon: 'solution'},
            {key: '/contractor/gas-safe', label: 'Gas Safe', icon: 'shop'},
            {key: '/contractor/qualifications', label: 'Qualifications', icon: 'form'},
            {key: '/contractor/engineers', label: 'Engineers', icon: 'book', children: [
                {key: '/contractor/engineers', label: 'Gas Engineers', icon: ''},
                {key: '/contractor/non-engineers', label: 'Non Gas Engineers', icon: ''}
            ]}
        ];

        const current = menuItems.find(i => i.key === selectedMenu);
        const selected = current && [current.key];
        const onCollapse = collapsed => {
            this.setState({
                collapsed
            })
        };
        const renderMenuItem = i => (
            <Menu.Item key={i.key} style={{overflow: 'hidden', whiteSpace: 'normal'}}>
                <Link to={i.key} style={{display: 'inline-block', width: '100%'}}>
                    {i.icon ? <span><Icon type={i.icon} /> {i.label}</span> : <span>{i.label}</span>}
                </Link>
            </Menu.Item>
        );
        const renderSubMenu = i => (
            <Menu.SubMenu title={<span><Icon type={i.icon} /><span>{i.label}</span></span>} key={i.key}>
                {i.children.map(renderMenuItem)}
            </Menu.SubMenu>
        );
        const renderItem = i => {
            if (i.children) {
                return renderSubMenu(i);
            }
            return renderMenuItem(i)
        };
        return (
            <Sider
                id="sider"
                width={250}
                style={{ background: '#fff' }}
                collapsible
                collapsed={this.state.collapsed}
                onCollapse={onCollapse}
                breakpoint="sm"
            >
                <Menu
                    defaultSelectedKeys={selected}
                    style={{ height: '100%', paddingTop: '24px' }}
                    mode='inline'
                >
                    {menuItems.map(renderItem)}
                </Menu>
            </Sider>
        );
    }
}

export default Sidebar;


// WEBPACK FOOTER //
// ./resources/assets/js/components/contractor/Sidebar.js